export const NOTIFICATION_TYPES = {
  BIOMETRIA_EVENTO:  'biometria-evento',
  SOLICITUD_CHANGED: 'solicitud-web-changed',
};
